import React, { memo } from 'react'

import { Button, Icon, ErrorOutlined, Refresh } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { iconSize } from 'Pods/ThreeDStudio/constants'

const errorIcon = <Icon svgComponent={ErrorOutlined} size={iconSize} notSpaced />
const retryIcon = <Icon svgComponent={Refresh} size={iconSize} notSpaced />

// Failed turn: danger title, explanation and a "Generate again" retry chip.
function FailedState({ onGenerateAgain }) {
  return (
    <div className="image-assistant-panel__failed">
      <span className="image-assistant-panel__failed-title cgt-body-base-semibold">
        {errorIcon}
        Generation failed
      </span>
      <p className="image-assistant-panel__failed-text cgt-body-base">
        Something went wrong while generating your image. Please try again.
      </p>
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        customClass="image-assistant-panel__failed-retry"
        icon={retryIcon}
        onClick={onGenerateAgain}
      >
        Generate again
      </Button>
    </div>
  )
}

FailedState.propTypes = {
  onGenerateAgain: func.isRequired,
}

export default memo(FailedState)
